var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-report-page"},[_c('div',{staticStyle:{"margin-top":"15px"}}),_c('ai-mode')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }